var map = {
	"./1.svg": "ecd6",
	"./2.svg": "46b0",
	"./3.svg": "d702",
	"./4.svg": "de5f",
	"./5.svg": "84e8",
	"./v_1.svg": "eba4",
	"./v_2.svg": "705b",
	"./v_3.svg": "57cf",
	"./v_4.svg": "251d",
	"./v_5.svg": "265a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44fd";